
import React, { Component } from 'react'
import { Link } from 'react-router-dom';

const LINKS = [{'link':"/home/readandselect/",'text':"Read and Select Questions"},
{'link':"/home/readandcomplete/",'text':"Read and Complete Questions"},
{'link':"/home/listenandtype/",'text':"Listen and Type Questions"},
{'link':"/home/readaloud/",'text':"Read Aloud Questions"},
{'link':"/home/interactivereading/",'text':"Interactive Reading"},
{'link':"/home/readthenwrite/",'text':"Read Then Write"},
{'link':"/home/readthenspeak/",'text':"Read Then Speak"},
{'link':"/home/listenthenspeak/",'text':"Listen Then Speak"},
{'link':"/home/writeaboutphoto/",'text':"Write About Photo"},
{'link':"/home/speakaboutphoto/",'text':"Speak About Photo"},
{'link':"/home/interactivelistening/",'text':"Interactive Listening"}]
           

export default class Menu extends Component {


  constructor(props) {
    super(props)
    this.toggleDropdown = this.toggleDropdown.bind(this)
  }
  state={}

   render() {
    const {token, profile} = this.props;
    const {usersubscription} = profile;
    const paidtill = usersubscription?.paidtill;
    const {showDropdown} = this.state;
    const isPaidtillNullOrUndefined = (paidtill === null || paidtill === undefined);
    let currentTask='';
    LINKS.forEach(l=>{if (~window.location.href.indexOf(l.link)){currentTask=l.text}});

    return (
        <div className='' style={{paddingLeft:'80px', position:'relative',top:'-2.9em'}}>
        <div className='row menu-container align-items-center' >
          <div className='col-5'>
              <div className='greetings text-white'>
              👋 Greetings {(profile?.username || '').slice(0,8)}
            </div>
          </div>
          <div className='col-auto text-right ps-0 pe-1'>
            <label className="col-auto">Tasks:</label>
          </div>
          
          <div className='col-auto p-0 tasks' onClick={this.toggleDropdown}>
            <div className={`dropdown  ${showDropdown?'show':''}`}>
              <button  className=" small btn bg-white text-black px-1 dropdown-toggle" type="button" id="dropdownMenuButton" aria-haspopup="true" aria-expanded={showDropdown}>
                {currentTask}
              </button>
              <div className={`dropdown-menu mt-2 ${showDropdown?'show':''}`} aria-labelledby="dropdownMenuButton">
                {LINKS.map((l,i)=><Link key={`link-${i}`} to={l.link} className="dropdown-item">{l.text}</Link>)}
                
              </div>
            </div>         
          </div>
          <div className='col-auto'>|</div>
          <div className='col-auto text-right ps-0 pe-1'>
            <label htmlFor="difficulty" className="col-auto">Difficulty:</label>
          </div>
          
          <div className='col-auto p-0'>
          
           <select id="difficulty" defaultValue={1} onChange={this.props.onDifficultyChange} className="form-select form-select-inline" aria-label="Difficulty">
                          <option value="1">Easy</option>
                          <option value="2">Medium</option>
                          <option value="3">Hard</option>
                        </select>
          </div>
        </div>
        {isPaidtillNullOrUndefined && <div className='mt-5 w-100  text-warning fw-bold' >
              <span hidden>TODO: Fix formatting</span>You are using a free account. The number of questions that you can see is limited. <Link to='/home/buysubscription'> buy subscription</Link>
            </div>
        } 
        {!(isPaidtillNullOrUndefined) && usersubscription?.is_paidtillfuture === false && <div className='mt-5 w-100  text-warning fw-bold' >
              <span hidden>TODO: Fix formatting</span>Your subscription is expired <Link to='/home/buysubscription'> renew now</Link>.
            </div>
        }    
      </div>
    )
  }

  toggleDropdown(){
    this.setState({showDropdown:!this.state.showDropdown})
  }
}

